export const FETCH_CASTS_DETAILS = 'FETCH_CASTS_DETAILS'


export const FETCH_CASTS_REQUEST = 'FETCH_CASTS_REQUEST'
export const FETCH_CASTS_SUCCESS = 'FETCH_CASTS_SUCCESS'